import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

// routes
import routes from "../routes.js";

var ps;

class Empty extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            backgroundColor: "black",
            activeColor: "info",
        };
        this.mainPanel = React.createRef();
    }
    componentDidMount() {
        this.getRoutes();
        if (navigator.platform.indexOf("Win") > -1) {
            ps = new PerfectScrollbar(this.mainPanel.current);
            document.body.classList.toggle("perfect-scrollbar-on");
        }
    }
    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1) {
            ps.destroy();
            document.body.classList.toggle("perfect-scrollbar-on");
        }
    }
    componentDidUpdate(e) {
        if (e.history.action === "PUSH") {
            this.mainPanel.current.scrollTop = 0;
            document.scrollingElement.scrollTop = 0;
        }
    }

    getRoutes = () => {
        let _routes = [];
        routes.map((prop, key) => {
            if (!prop.submenus) {
                _routes.push({
                    layout: prop.layout,
                    path: prop.path,
                    component: prop.component,
                    name: prop.name,
                    icon: prop.icon
                })
            }
            else {
                prop.submenus.map((subprop, subkey) => {
                    _routes.push({
                        layout: prop.layout,
                        path: subprop.path,
                        component: subprop.component,
                        name: subprop.name,
                        icon: subprop.icon
                    })
                })
            }
        })

        this.setState({ routes: _routes, routesSidebar: routes });
    }

    render() {
        return (
            <div ref={this.mainPanel}>
                <Switch>
                    {this.state.routes && this.state.routes.map((prop, key) => {
                        return (
                            <Route
                                path={prop.layout + prop.path}
                                component={prop.component}
                                key={key}
                            />
                        );
                    })}
                </Switch>
            </div>
        );
    }
}

export default Empty;
